import { render, staticRenderFns } from "./BsOverlay.vue?vue&type=template&id=a9e640ee&"
import script from "./BsOverlay.vue?vue&type=script&lang=js&"
export * from "./BsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BsOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports